import { render, staticRenderFns } from "./grid-posts.component.vue?vue&type=template&id=413865c0&"
import script from "./grid-posts.component.vue?vue&type=script&lang=js&"
export * from "./grid-posts.component.vue?vue&type=script&lang=js&"
import style0 from "./grid-posts.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports